import { render, staticRenderFns } from "./Dialog_TeacherGrantShop.vue?vue&type=template&id=4579a85e&scoped=true&"
import script from "./Dialog_TeacherGrantShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_TeacherGrantShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579a85e",
  null
  
)

export default component.exports